import React from "react";

export interface ValidationErrors {
  [key: string]: string[];
}

export interface FilterProps {
  onFieldChange: (arg: { [fieldName: string]: any }) => any;
  inputs?: Record<string, any>;
  children?: React.ReactNode;
}

export interface ModalProps {
  defaultValue?: any;
  visible: boolean;
  onClose: () => any;
  destroyOnClose?: boolean;
}

export interface TableState {
  hiddenColumns?: string[];
  columnOrder?: string[];
}

export interface TagsDropdownOptionProps {
  id: number;
  label?: string;
  value?: string;
  icon?: string;
}

export interface DropdownOption {
  key?: number;
  label: string;
  value?: string;
}

export enum EChevronType {
  Next = "next",
  Previous = "previous",
}

export type ForgotPasswordStep = "input" | "verify" | "confirm" | "success";
